import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

function getShockwaveContents() {
	return supabaseClient
		.from("shockwave_contents")
		.select("*")
		.throwOnError()
		.then((result) => result.data);
}

export const shockwave_contents_key = ["shockwave-contents"];

export const shockwaveContentsQueryOptions = () => {
	return queryOptions({
		queryKey: shockwave_contents_key,
		queryFn: async () => getShockwaveContents(),
	});
};

export function useShockwaveContentsQuery() {
	return useQuery(shockwaveContentsQueryOptions());
}
